var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.task)?_c('div',[_c('progress',{staticClass:"progress is-info",attrs:{"max":"100"},domProps:{"value":_vm.task.progress}},[_vm._v(" "+_vm._s(_vm.task.progress)+"% ")]),(_vm.lastComment)?_c('p',[_vm._v(_vm._s(_vm.lastComment))]):_vm._e()]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }